import {Directive, HostListener, input, output} from '@angular/core';
import {ComponentEntity} from "../entities/component-entity";
import {CONSTANTS, ROUTER_VIEW} from "../commons/constans";
import {Router} from "@angular/router";
import {defaultComponentEntity} from "../commons/defaults-components";
import {AmadWebNetworkService} from "../network/amad-web-network.service";

@Directive({
  selector: '[appClickComponent]',
  standalone: true
})
export class ClickComponentDirective {

  clicked =  output<void>();
  dataComponent = input<ComponentEntity>(defaultComponentEntity());

  constructor(private router: Router,
              private amadWebNetwork:AmadWebNetworkService ) {

  }
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent): void {
    this.goTo()
    this.clicked.emit();
  }

  goTo() {

    this.amadWebNetwork.sendClicks({
      id_action:this.dataComponent().properties.idAnalytics ?? CONSTANTS.EMPTY_STRING,
      other_information: this.dataComponent().properties.actionAnalytics  ?? CONSTANTS.EMPTY_STRING
    }).subscribe(value => console.log(value));
    if(this.dataComponent().actions.openSections){
      this.router
        .navigate([`/${ROUTER_VIEW}`, this.dataComponent().actions.openSections ?? ""])
        .then(r => console.log("Envio de hacia->")) ;
      return
    }
    if(this.dataComponent().actions.openWebView){
      window.open(`${this.dataComponent().actions.openWebView}`,"_blank")
      return
    }

    if(this.dataComponent().actions.call){
      window.open(`tel:${this.dataComponent().actions.call}`)
      return
    }
  }
}
